import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import React from 'react'
import styled from 'styled-components'

const ModalBody: React.FC<FlexProps> = ({ children, ...props }) => {
  return (
    <StyledModalBody className="wrap-body-container" {...props}>
      {children}
    </StyledModalBody>
  )
}

const StyledModalBody = styled(Flex).attrs(
  (
    props: FlexProps & {
      gap?: string
    },
  ) => ({
    overflowY: props.overflowY || 'auto',
    padding: props.padding || '20px',
  }),
)`
  flex-direction: column;
  flex: 1;
  position: relative;
  width: 100%;
  height: 100%;

  overflow-x: hidden;

  ::-webkit-scrollbar-track {
    margin: 16px 0;
  }
`

export default ModalBody
